``<template>
  <div class="container-fluid">
    <div class="container-fluid">
      <div class="d-flex justify-content-center">     
        <q-linear-progress v-if="!chartLoaded" indeterminate />

        <q-btn v-else outline v-show="false" id="export-to-csv-btn" no-caps color="green" label="Export Raw Data as CSV"
                    v-on:click="getDemographicExportCSV()" />
      </div>

      <div class="graph-container">
        <div v-if="chartLoaded && iwiChartData" class="graph-chart medium-graph">
          <Pie v-bind:chartData="this.iwiChartData"
            v-bind:chartOptions="iwiChartOptions" />
        </div>

        <div v-if="chartLoaded && ageChartData" class="graph-chart medium-graph">
          <Pie v-bind:chartData="this.ageChartData" v-bind:chartOptions="ageChartOptions" />
        </div>

        <div v-if="chartLoaded && genderChartData" class="graph-chart medium-graph">
          <Pie v-bind:chartData="this.genderChartData" v-bind:chartOptions="genderChartOptions" />
        </div>

        <div v-if="chartLoaded && ethnicityChartData" class="graph-chart medium-graph">
          <Pie v-bind:chartData="this.ethnicityChartData" v-bind:chartOptions="ethnicityChartOptions" />
        </div>
      </div>
    </div>
    <q-inner-loading
        :showing="visible"
        label="Please wait..."
        label-class="text-teal"
        label-style="font-size: 1.1em"
      />
  </div>

</template>

<script>


import api from "../../services/api/api"
import notify from '@/services/util/notify';

import Pie from "../ChartComponents/Pie.vue"
import { retPieOptions } from "../DataComponents/chartOptions"

export default ({
  name: 'ClientDemographics',
  components: { Pie},

  props: ['query'],

  data() {
    return {
      formattedDemographic: {},

      chartLoaded: false,

      genderChartData: null,
      iwiChartData: null,
      ageChartData: null,
      referralChartData: null,
      engagedChartData: null,
      entryChartData: null,
      interactionChartData: null,
      waitlistChartData: null,
      ethnicityChartData: null,

      genderChartOptions: retPieOptions("Genders", "Gender"),
      ageChartOptions: retPieOptions("Age Ranges", "Age"),
      iwiChartOptions: retPieOptions("Top 10 Primary Iwi Groups", "Iwi"),
      ethnicityChartOptions: retPieOptions("Top 10 Primary Ethnicity Groups", "Ethnicity"),

      visible: false,
    }
  },


  created() {
    this.onIntialize();
        
  },


  methods: {

    /**
     * Set all the required chart data and chart options.
     */
    onIntialize() {

      // Fetch all client data from backend. Returns list of data once all requests have completed
      const fetchData = function (query) {
        return Promise.all([
          api.clientGraph.clientGender(query).catch(error => ({ error })),
          api.clientGraph.clientAge(query).catch(error => ({ error })),
          api.clientGraph.clientIwi(query).catch(error => ({ error })),
          api.clientGraph.clientEthnicity(query).catch(error => ({ error })),
        ]);
      };

      fetchData(this.query).then((values) => {
        // Filter out the errors
        const chartData = values.map(value => value.error ? null : value.data);

        // Assign the chart data
        this.genderChartData = chartData[0];
        this.ageChartData = chartData[1];
        this.iwiChartData = chartData[2];
        this.ethnicityChartData = chartData[3];

        this.$emit("displayErrors", values);

      }).catch(() => {
        // Handle errors here if necessary
        notify.error("Error retrieving client demographic data", 'top');

      }).finally(() => {
        this.chartLoaded = true;
      });
    },


    /**
     * @desc Retrieves client demographic information as a CSV file
     */
    getDemographicExportCSV(){
      api.client.getClientDemographicCSVExport(this.formattedDemographic).then(() => {
        notify.primary("Successfully download CSV file!", "top")
      }).catch(() => {
          notify.error("There was an error downloading the CSV file.", "top");
      })
    }
    
  },
})



</script>

<style scoped>
@import '../../assets/styles/clientDemographics.css';
</style>